import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import { PurchaseOrderValues } from 'purchaseOrder/view/types';
import {
  NotePurchaseOrderCreate,
  NotePurchaseOrderCreateVariables,
} from 'common/graphql/__generated__/NotePurchaseOrderCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_PURCHASE_ORDER_CREATE from 'common/graphql/NotePurchaseOrderCreate.graphql';

type NotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  id: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const Notes: React.FC<NotesProps> = ({
  id,
  listRefreshRequest,
  data,
  loading,
}) => {
  return (
    <GenericNotesSection<
      PurchaseOrderValues,
      NotePurchaseOrderCreate,
      NotePurchaseOrderCreateVariables
    >
      entityId={id}
      data={data}
      loading={loading}
      mutationDocument={NOTE_PURCHASE_ORDER_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
